<template>
  <div :class="['plat-data-panel-select', {'is-border': border}]"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="isAllLoad">
      <template v-if="noDataLabel && noDataLabel.length">
        <Hint type="empty">
          <div>{{noDataLabel.join('、')}}数据为空</div>
        </Hint>
      </template>
      <template v-else>
        <div class="header">
          <div class="label">
            <div v-for="item in selectData"
                 :key="item.key"
                 :class="['data-range', 'data-' + item.dataType]">
              <span v-if="showLabel"
                    class="custom-label">{{$attrs[`${item.dataType}Label`] || item.label}}</span>
              <template v-if="item.dataType === 'site'">
                <template v-if="siteGroup">
                  <el-cascader v-model="select[item.dataType]"
                               size="mini"
                               :options="item.groupData"
                               :props="groupProps"></el-cascader>
                </template>
                <template v-else>
                  <el-select v-model="select[item.dataType]"
                             size="mini"
                             filterable>
                    <el-option v-for="val in item.data"
                               :key="val.id"
                               :label="val.name"
                               :value="val.id"/>
                  </el-select>
                </template>
              </template>
              <template v-else>
                <el-select v-model="select[item.dataType]"
                           size="mini"
                           filterable>
                  <el-option v-for="val in item.data"
                             :key="val.id"
                             :label="val.name"
                             :value="val.id"/>
                </el-select>
              </template>
            </div>
          </div>
          <div v-if="$scopedSlots.extra"
               class="extra">
            <slot name="extra"
                  v-bind="select"></slot>
          </div>
        </div>
        <div class="main">
          <div class="main-cont">
            <slot v-bind="select"></slot>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>请求数据加载失败</div>
        <el-button type="text"
                   @click="loadData">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/custom/wrapper'
export default {
  name: 'PlatDataPanelSelect',
  mixins: [Wrapper],
  components: {
    Hint
  },
  props: {
    dataTypes: {
      type: Array,
      required: true,
      validator: val => !!val.length
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    siteGroup: Boolean
  },
  data () {
    return {
      dataRange: {
        site: {
          url: '/workspace/manager/portal/data/select/sites',
          key: 'sites',
          label: '教学点',
          data: null,
          groupData: null
        },
        grade: {
          url: '/workspace/manager/portal/data/select/grades',
          key: 'grades',
          label: '年级',
          data: null
        },
        semester: {
          url: '/workspace/manager/portal/data/select/semesters',
          key: 'semesters',
          label: '学期',
          data: null
        }
      },
      groupProps: {
        label: 'name',
        value: 'id',
        emitPath: false
      },
      loading: false,
      select: {}
    }
  },
  computed: {
    isAllLoad () {
      return this.dataTypes.every(dataType => !!this.dataRange[dataType].data)
    },
    selectData () {
      return this.dataTypes.map(dataType => {
        return {
          dataType,
          ...this.dataRange[dataType]
        }
      })
    },
    noDataLabel () {
      return this.selectData.filter(option => !option.data || !option.data.length)
        .map(option => option.label)
    }
  },
  methods: {
    loadData () {
      let promises = this.dataTypes.map(dataType => {
        let option = this.dataRange[dataType]
        return this.$ajax({
          url: option.url,
          method: 'post'
        })
      })
      this.loading = true
      Promise.all(promises).then(result => {
        this.dataTypes.forEach((dataType, index) => {
          let option = this.dataRange[dataType]
          option.data = result[index].data[option.key] || []
          if (dataType === 'site') {
            let siteUnits = result[index].data['siteUnits'] || []
            option.groupData = siteUnits.map(siteUnit => {
              let children = option.data.filter(site => site.siteUnit === siteUnit.code)
              return this.$extend({
                children
              }, siteUnit)
            })
          }
        })
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    selectData (val) {
      if (val && val.length) {
        val.forEach(option => {
          let data = option.data
          if (data && data.length) {
            let getVal = data.find(v => v.active)
            if (!getVal) {
              let lastValId = this.getWrapper(option.dataType)
              if (lastValId) {
                getVal = data.find(v => v.id === lastValId)
              }
            }
            if (getVal) {
              this.$set(this.select, option.dataType, getVal.id)
            } else {
              this.$set(this.select, option.dataType, data[0].id)
            }
          }
        })
      }
    },
    select: {
      handler (data) {
        if (data) {
          this.selectData.forEach(option => {
            let val = data[option.dataType]
            if (val) {
              this.setWrapper(option.dataType, val)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .plat-data-panel-select {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    &.is-border {
      & > .header {
        border-bottom: 1px solid #ebeef5;
      }
    }
    & > .header {
      flex: none;
      height: 46px;
      padding: 0 15px;
      line-height: 46px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      & > .label {
        flex: auto;
        display: flex;
        align-items: center;
        white-space: nowrap;
        & > .data-range {
          &.data-site {
            .el-cascader {
              width: 260px;
            }
            .el-select {
              width: 180px;
            }
          }
          &.data-grade {
            .el-select {
              width: 100px;
            }
          }
          &.data-semester {
            .el-select {
              width: 132px;
            }
          }
          .custom-label {
            margin-right: 8px;
            font-size: 13px;
          }
          & + .data-range {
            margin-left: 20px;
          }
        }
      }
      & > .extra {
        margin-left: 15px;
        flex: none;
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
